import btn from './index.vue'
const FileButton = {
  install: function (Vue) {
    Vue.component('FileButton', btn)
  }
}
export default FileButton
